module.exports = __webpack_public_path__ + "4c6c87f140b1583bb34cba591495cf88.MP3";